"use client";
import { Overlay } from "../Overlay/Overlay.mjs";
import { Transition } from "../Transition/Transition.mjs";
import { useModalBaseContext } from "./ModalBase.context.mjs";
import { useModalTransition } from "./use-modal-transition.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseOverlay.tsx
function ModalBaseOverlay({ onClick, transitionProps, style, visible, ...others }) {
	const ctx = useModalBaseContext();
	const transition = useModalTransition(transitionProps);
	return /* @__PURE__ */ jsx(Transition, {
		mounted: visible !== void 0 ? visible : ctx.opened,
		...transition,
		transition: "fade",
		children: (transitionStyles) => /* @__PURE__ */ jsx(Overlay, {
			fixed: true,
			style: [style, transitionStyles],
			zIndex: ctx.zIndex,
			unstyled: ctx.unstyled,
			onClick: (event) => {
				onClick?.(event);
				ctx.closeOnClickOutside && ctx.onClose();
			},
			...others
		})
	});
}
ModalBaseOverlay.displayName = "@mantine/core/ModalBaseOverlay";
//#endregion
export { ModalBaseOverlay };

//# sourceMappingURL=ModalBaseOverlay.mjs.map